<script setup>
const staticURLImg = useRuntimeConfig().public.staticURLImg
</script>

<template>
    <v-row id="customui" class="justify-center slide-from-left">
        <v-col cols="12" sm="10" class="my-16 rounded">
            <v-row>
                <!-- <v-col cols="12" class="text-h4 text-md-h3 text-center font-weight-medium st-text-shadow">
                    Elevate Your Brand with Custom GUIs
                </v-col> -->
                <v-col cols="12">
                    <app-section-header :id="`cgui`" :title="`Elevate Your Brand with Custom GUIs`" :subtitle="``" />
                </v-col>
                <v-col cols="12" class="text-center st-card-text-grey-lt2">
                    A custom GUI, or skin, is more than just a logo slapped on an interface. It's a powerful marketing
                    tool that reflects your brand identity and enhances user experience. We specialize in creating
                    unique GUIs.
                </v-col>

                <v-col cols="12" sm="12" md="4">
                    <v-card variant="flat" class="st-card pa-3 text-center st-box-shadow">
                        <v-card-item>
                            <v-icon color="light-blue-darken-2" size="48"> mdi-gift-open </v-icon>
                            <v-card-title class="my-2 text-h5 text-wrap"> Reward Customers </v-card-title>
                        </v-card-item>
                        <v-img
                            id="cardImg"
                            :src="staticURLImg + `excs-custom-ui-bundle.webp`"
                            class="rounded elevation-1"
                            alt="Custom gui bundle"
                        ></v-img>
                        <v-card-text class="pa-2 st-card-text text-justify">
                            Increase perceived value by offering a cohesive look and feel when users combine your
                            products. We've created custom skins for Bjulin and Swan Audio that they bundled with their
                            sound packs, and a Fishman-branded skin for KV331 Audio's SynthMaster One plugin, bundled
                            with Fishman's Triple Play.
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <v-card variant="flat" class="st-card pa-3 text-center st-box-shadow">
                        <v-card-item>
                            <v-icon color="green-darken-3" size="48"> mdi-desk </v-icon>
                            <v-card-title class="my-2 text-h5 text-wrap"> Inspire Your Workflow </v-card-title>
                        </v-card-item>
                        <v-img id="cardImg" :src="staticURLImg + `excs-workflow.webp`" class="rounded"></v-img>
                        <v-card-text class="pa-2 st-card-text text-justify">
                            Enhance your creative process with a custom UI designed for your specific needs. Our Spire
                            Polar skin for Sterling Angel is a perfect example, designed for an inspiring and focused
                            workflow.
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <v-card variant="flat" class="st-card pa-3 text-center st-box-shadow">
                        <v-card-item>
                            <v-icon color="amber-accent-4" size="48"> mdi-stamper </v-icon>
                            <v-card-title class="my-2 text-h5 text-wrap"> Brand Collaboration </v-card-title>
                        </v-card-item>
                        <v-img id="cardImg" :src="staticURLImg + `excs-burak-yeter.webp`" class="rounded"></v-img>
                        <v-card-text class="pa-2 st-card-text text-justify">
                            Showcase your signature style or collaborate with a popular producer or artist to create a
                            limited-edition skin. Check out our SynthMaster Burak Yeter Edition skin for inspiration.
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="6">
                    <v-card variant="flat" class="st-card pa-3 text-center st-box-shadow">
                        <v-card-item>
                            <v-icon color="deep-orange" size="48"> mdi-star-shooting </v-icon>
                            <v-card-title class="my-2 text-h5 text-wrap"> Beyond Customization </v-card-title>
                        </v-card-item>
                        <v-card-text class="st-card-text text-justify">
                            Looking to personalize an existing skin from our library? We offer licensing options for
                            many of our creations.
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="6">
                    <v-card variant="flat" class="st-card pa-3 text-center st-box-shadow">
                        <v-card-item>
                            <v-icon color="deep-purple" size="48"> mdi-help-rhombus </v-icon>
                            <v-card-title class="my-2 text-h5 text-wrap"> Ready for a Special Edition? </v-card-title>
                        </v-card-item>
                        <v-card-text class="st-card-text text-justify">
                            Contact us today! We will customize a skin and develop a unique edition just for you.
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" class="my-4 text-center">
                    <v-btn
                        text="Explore Now"
                        to="/services/customgui"
                        size="x-large"
                        color="deep-orange-accent-4"
                        aria-label="Explore Custom GUI Service"
                    ></v-btn>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<style scoped></style>
